import LocaleService from 'services/loader-handler-services/locale-service';
import { KeybindingService, keys } from 'services/event-handler-services/keybinding-service';
import $ from 'jquery';

const { Enter } = keys;

const DragAndDropKeyboard = function ($page, draggersSelector, droppersSelector, callback) {
  const self = this;
  self.draggersSelector = draggersSelector;
  self.droppersSelector = droppersSelector;
  self.$page = $page;
  self.callback = callback;
  self.$curDragger = null;

  /**
   * Call this to initilize the keyboard handler.  the only 'public' method you need to call
   */
  self.init = function (model) {
    // Prevent the event from being attached multiple times
    self.$page.off('keydown', draggersSelector);

    self.$page.on('keydown', draggersSelector, function (e) {
      KeybindingService.with(e).bind(Enter, () => {
        const lastDropSlot = $page.find(self.droppersSelector).length - 1;
        const startChar = 65;
        const lastChar = startChar + lastDropSlot;
        let optionsText = '';
        $page.find(self.droppersSelector).each((idx, val) => {
          const choices = LocaleService.t('drag-and-drop.kbtext', {
            keyChar: String.fromCharCode(65 + idx),
            text: $(val).children().first().text(),
          });
          optionsText += `<p>${choices}</p>`;
        });
        const instructions = LocaleService.t('drag-and-drop.kbInstructions', {
          firstChar: String.fromCharCode(startChar),
          lastChar: String.fromCharCode(lastChar),
        });
        self.$page.find('.srInstructions').html(instructions);
        self.$page.find('.srText').html(optionsText);
        const $item = $(e.target);
        //filter not events for non draggables, like the text box on communication strengths activity
        if ($item.hasClass('ui-draggable')) {
          self.$curDragger = $(e.target);

          // usualy drag-n-drops with only one drop spot should have this flag,
          // pressing enter alone will move the focused drag element
          if (model.attributes.a11y_info && model.attributes.a11y_info.remove_keyboard_options) {
            callback(self.$curDragger, $(droppersSelector));
          } else {
            self.createKeyboardShortcuts();
            self.attachKeyboardHandler();
            e.preventDefault();
          }
        }
      });
    });
  };

  /**
   * Listens to the document using live binding, this way it works with draggers as they get cloned
   */
  self.attachKeyboardHandler = function () {
    self.$page.on('keydown.globalShortcut', function (e) {
      KeybindingService.with(e).bind(/[a-zA-Z]/, () => {
        const $destination = self.$page.find(`div.keyboardShortcut[data-char='${e.key.toUpperCase()}']`);
        if (callback) {
          callback(self.$curDragger, $destination.parent());
        }
      });
      const answer = self.$page.find('.srCorrectIncorrectAnswer');
      if (self.$curDragger.hasClass('correct')) {
        answer.text(LocaleService.t('drag-and-drop.correct'));
      } else {
        answer.text(LocaleService.t('drag-and-drop.incorrect'));
      }
      self.stopKeyboardShortcuts();
    });
  };

  /**
   * cancel the listener that is attached after you press Enter on a dragger
   */
  self.stopKeyboardShortcuts = function () {
    //only listen to the next key event
    self.$page.off('keydown.globalShortcut');
    self.$page.find('div.keyboardShortcut').remove();
    self.$page.find('div.srInstructions').empty();
    self.$page.find('div.srText').empty();
    self.$curDragger = null;
  };

  /**
   * Create the temporary visual keyboard short cut labels
   */
  self.createKeyboardShortcuts = function () {
    self.$page.find('.srCorrectIncorrectAnswer').empty();
    const $dropSlots = $page.find(self.droppersSelector);
    let startChar = 65;
    $dropSlots.each(function () {
      const $this = $(this);
      const correctDrop = self.$curDragger[0].dataset.correct === 'true' ? true : false;
      if (!$this.droppable('option', 'disabled') && !correctDrop) {
        //TODO: limit to 26 chars
        const newChar = String.fromCharCode(startChar++);
        $this.append(`<div class='keyboardShortcut' data-char='${newChar}'> ${newChar}</div>`);
      }
    });
  };
};

export default DragAndDropKeyboard;
